import config from 'config'

const ProductId = {
    S:config.isDebug?"9":"8",
    M:config.isDebug?"10":"7",
    L:config.isDebug?"11":"6",
    S_SVG:config.isDebug?"862":"2749",
    M_SVG:config.isDebug?"864":"2751",
    L_SVG:config.isDebug?"866":"2754",
    S_SHARE:config.isDebug?"863":"2750",
    M_SHARE:config.isDebug?"865":"2752",
    L_SHARE:config.isDebug?"867":"2755",
    S_SVG_SAMPLE:config.isDebug?"873":"3773",
    M_SVG_SAMPLE:config.isDebug?"875":"3775",
    L_SVG_SAMPLE:config.isDebug?"877":"3777",
    S_SHARE_SAMPLE:config.isDebug?"874":"3774",
    M_SHARE_SAMPLE:config.isDebug?"876":"3776",
    L_SHARE_SAMPLE:config.isDebug?"878":"3778",

    S_ACRYLIC_COUPON:config.isDebug?"890":"3842",
    M_ACRYLIC_COUPON:config.isDebug?"891":"3843",
    L_ACRYLIC_COUPON:config.isDebug?"892":"3844",
    S_ACRYLIC_COUPON_D:config.isDebug?"893":"3845",
    M_ACRYLIC_COUPON_D:config.isDebug?"894":"3846",
    L_ACRYLIC_COUPON_D:config.isDebug?"895":"3847",

    // ACRY TICKETの送料分の金額（明細をわかりやすくするため）
    ACRY_TICKET_POSTAGE:config.isDebug?"902":"3854",

    // アクリー側のID、AcryProでは基本使用しない
    ACRY_ACRYLIC_COUPON_S_D:config.isDebug?"896":"3848",  // ACRYで作成される際のプロダクトID（送料あり）
    ACRY_ACRYLIC_COUPON_M_D:config.isDebug?"897":"3849",
    ACRY_ACRYLIC_COUPON_L_D:config.isDebug?"898":"3850",
    ACRY_ACRYLIC_COUPON_S:config.isDebug?"899":"3851",  // ACRYで作成される際のプロダクトID（送料なし）
    ACRY_ACRYLIC_COUPON_M:config.isDebug?"900":"3852",
    ACRY_ACRYLIC_COUPON_L:config.isDebug?"901":"3853",
}

const AcrylProductIds = [
    ProductId.S, ProductId.M, ProductId.L,
    ProductId.S_SVG, ProductId.M_SVG, ProductId.L_SVG,
    ProductId.S_SHARE, ProductId.M_SHARE, ProductId.L_SHARE,
];

const AcrylSampleProductIds = [
    ProductId.S_SVG_SAMPLE, ProductId.M_SVG_SAMPLE, ProductId.L_SVG_SAMPLE,
    ProductId.S_SHARE_SAMPLE, ProductId.M_SHARE_SAMPLE, ProductId.L_SHARE_SAMPLE,
];

const AcrylSvgProductIds = [
    ProductId.S_SVG, ProductId.M_SVG, ProductId.L_SVG,
    ProductId.S_SVG_SAMPLE, ProductId.M_SVG_SAMPLE, ProductId.L_SVG_SAMPLE,
];

const AcrylShareProductIds = [
    ProductId.S_SHARE, ProductId.M_SHARE, ProductId.L_SHARE,
    ProductId.S_SHARE_SAMPLE, ProductId.M_SHARE_SAMPLE, ProductId.L_SHARE_SAMPLE,
];


const AcrylTicketIds = [
    ProductId.S_ACRYLIC_COUPON, ProductId.M_ACRYLIC_COUPON, ProductId.L_ACRYLIC_COUPON,
    ProductId.S_ACRYLIC_COUPON_D, ProductId.M_ACRYLIC_COUPON_D, ProductId.L_ACRYLIC_COUPON_D,
];

const GetAcryProductPrice = function(productId){
    const priceData = {};
    priceData.priceBase = 0;
    priceData.price = 0;
    switch(productId){
        case ProductId.S:
            priceData.priceBase = 700;
            priceData.price = 770;
            break;
        case ProductId.M:
            priceData.priceBase = 1200;
            priceData.price = 1320;
            break;
        case ProductId.L:
            priceData.priceBase = 2400;
            priceData.price = 2640;
            break;
        case ProductId.S_SVG:
            priceData.priceBase = 700;
            priceData.price = 770;
            break;
        case ProductId.M_SVG:
            priceData.priceBase = 1200;
            priceData.price = 1320;
            break;
        case ProductId.L_SVG:
            priceData.priceBase = 2400;
            priceData.price = 2640;
            break;
        case ProductId.S_SHARE:
            priceData.priceBase = 700;
            priceData.price = 770;
            break;
        case ProductId.M_SHARE:
            priceData.priceBase = 1200;
            priceData.price = 1320;
            break;
        case ProductId.L_SHARE:
            priceData.priceBase = 2400;
            priceData.price = 2640;
            break;
        case ProductId.S_SVG_SAMPLE:
            priceData.priceBase = 100;
            priceData.price = 110;
            break;
        case ProductId.M_SVG_SAMPLE:
            priceData.priceBase = 200;
            priceData.price = 220;
            break;
        case ProductId.L_SVG_SAMPLE:
            priceData.priceBase = 300;
            priceData.price = 330;
            break;
        case ProductId.S_SHARE_SAMPLE:
            priceData.priceBase = 100;
            priceData.price = 110;
            break;
        case ProductId.M_SHARE_SAMPLE:
            priceData.priceBase = 200;
            priceData.price = 220;
            break;
        case ProductId.L_SHARE_SAMPLE:
            priceData.priceBase = 300;
            priceData.price = 330;
            break;

        case ProductId.S_ACRYLIC_COUPON:
            priceData.priceBase = 700;
            priceData.price = 770;
            break;
        case ProductId.M_ACRYLIC_COUPON:
            priceData.priceBase = 1200;
            priceData.price = 1320;
            break;
        case ProductId.L_ACRYLIC_COUPON:
            priceData.priceBase = 2400;
            priceData.price = 2640;
            break;
        case ProductId.S_ACRYLIC_COUPON_D:
            priceData.priceBase = 700;
            priceData.price = 770;
            break;
        case ProductId.M_ACRYLIC_COUPON_D:
            priceData.priceBase = 1200;
            priceData.price = 1320;
            break;
        case ProductId.L_ACRYLIC_COUPON_D:
            priceData.priceBase = 2400;
            priceData.price = 2640;
            break;
        }
    return priceData;
}

const GetAcryProductSizeText = function(productId){
      switch (productId) {
        case ProductId.S:
        case ProductId.S_SVG:
        case ProductId.S_SHARE:
        case ProductId.S_SVG_SAMPLE:
        case ProductId.S_SHARE_SAMPLE:
        case ProductId.S_ACRYLIC_COUPON:
        case ProductId.S_ACRYLIC_COUPON_D:
          return "S";
        case ProductId.M:
        case ProductId.M_SVG:
        case ProductId.M_SHARE:
        case ProductId.M_SVG_SAMPLE:
        case ProductId.M_SHARE_SAMPLE:
        case ProductId.M_ACRYLIC_COUPON:
        case ProductId.M_ACRYLIC_COUPON_D:
          return "M";
        case ProductId.L:
        case ProductId.L_SVG:
        case ProductId.L_SHARE:
        case ProductId.L_SVG_SAMPLE:
        case ProductId.L_SHARE_SAMPLE:
        case ProductId.L_ACRYLIC_COUPON:
        case ProductId.L_ACRYLIC_COUPON_D:
          return "L";
      }
}

// プロダクID + classcategory_id2 で編集領域のサイズが決まる
const CanvasSizeData = {
    '8:0': [{
        // 34:55
        // 12
        width: 913, height: 1496,
        canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 790,
        canvasScreenPositionX: 0, canvasScreenPositionY: 0,
        canvasMiriMeterSizeWidth: 61, canvasMiriMeterSizeHeight: 100
    }, {
        width: 913, height: 1496,
        canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 790,
        canvasScreenPositionX: 0, canvasScreenPositionY: 0,
        canvasMiriMeterSizeWidth: 61, canvasMiriMeterSizeHeight: 100
    }],
    '7:0': [{
        width: 1376, height: 2244,
        canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 786,
        canvasScreenPositionX: 0, canvasScreenPositionY: 0,
        canvasMiriMeterSizeWidth: 92, canvasMiriMeterSizeHeight: 150
    }, {
        width: 1376, height: 2244,
        canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 786,
        canvasScreenPositionX: 0, canvasScreenPositionY: 0,
        canvasMiriMeterSizeWidth: 92, canvasMiriMeterSizeHeight: 150
    }],
    '6:0': [{
        width: 2080, height: 3336,
        canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 773,
        canvasScreenPositionX: 0, canvasScreenPositionY: 0,
        canvasMiriMeterSizeWidth: 139, canvasMiriMeterSizeHeight: 225
    }, {
        width: 2080, height: 3336,
        canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 773,
        canvasScreenPositionX: 0, canvasScreenPositionY: 0,
        canvasMiriMeterSizeWidth: 139, canvasMiriMeterSizeHeight: 225
    }],
    '9:0': [{
        // 34:55
        // 12
        width: 913, height: 1496,
        canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 790,
        canvasScreenPositionX: 0, canvasScreenPositionY: 0,
        canvasMiriMeterSizeWidth: 61, canvasMiriMeterSizeHeight: 100
    }, {
        width: 913, height: 1496,
        canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 790,
        canvasScreenPositionX: 0, canvasScreenPositionY: 0,
        canvasMiriMeterSizeWidth: 61, canvasMiriMeterSizeHeight: 100
    }],
    '10:0': [{
        width: 1376, height: 2244,
        canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 786,
        canvasScreenPositionX: 0, canvasScreenPositionY: 0,
        canvasMiriMeterSizeWidth: 92, canvasMiriMeterSizeHeight: 150
    }, {
        width: 1376, height: 2244,
        canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 786,
        canvasScreenPositionX: 0, canvasScreenPositionY: 0,
        canvasMiriMeterSizeWidth: 92, canvasMiriMeterSizeHeight: 150
    }],
    '11:0': [{
        width: 2080, height: 3336,
        canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 773,
        canvasScreenPositionX: 0, canvasScreenPositionY: 0,
        canvasMiriMeterSizeWidth: 139, canvasMiriMeterSizeHeight: 225
    }, {
        width: 2080, height: 3336,
        canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 773,
        canvasScreenPositionX: 0, canvasScreenPositionY: 0,
        canvasMiriMeterSizeWidth: 139, canvasMiriMeterSizeHeight: 225
    }],
}

const GetCanvasSize = function(productId){
    // 1.623
    // 1456*2359
    switch(productId){
        case ProductId.S:
            return {
                // 1.638
                width: 913, height: 1496,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 790,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 61, canvasMiriMeterSizeHeight: 100
            };
        case ProductId.M:
            return {
                // 1.630
                width: 1376, height: 2244,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 786,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 92, canvasMiriMeterSizeHeight: 150
            };
        case ProductId.L:
            return {
                // 1.603
                width: 2080, height: 3336,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 773,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 139, canvasMiriMeterSizeHeight: 225
            };
        case ProductId.S_SVG:
            return {
                // 1.638
                width: 913, height: 1496,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 790,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 61, canvasMiriMeterSizeHeight: 100
            };
        case ProductId.M_SVG:
            return {
                // 1.638
                width: 1376, height: 2244,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 790,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 92, canvasMiriMeterSizeHeight: 150
            };
        case ProductId.L_SVG:
            return {
                // 1.603
                width: 2080, height: 3336,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 773,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 139, canvasMiriMeterSizeHeight: 225
            };
        case ProductId.S_SHARE:
            return {
                // 1.6
                width: 1400, height: 2240,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 771,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 61, canvasMiriMeterSizeHeight: 100
            };
        case ProductId.M_SHARE:
            return {
                // 1.6
                width: 1400, height: 2240,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 771,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 92, canvasMiriMeterSizeHeight: 150
            };
        case ProductId.L_SHARE:
            return {
                // 1.605
                width: 2080, height: 3340,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 774,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 139, canvasMiriMeterSizeHeight: 225
            };
        case ProductId.S_SVG_SAMPLE:
            return {
                // 1.638
                width: 913, height: 1496,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 790,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 61, canvasMiriMeterSizeHeight: 100
            };
        case ProductId.M_SVG_SAMPLE:
            return {
                // 1.638
                width: 1376, height: 2244,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 790,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 92, canvasMiriMeterSizeHeight: 150
            };
        case ProductId.L_SVG_SAMPLE:
            return {
                // 1.603
                width: 2080, height: 3336,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 773,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 139, canvasMiriMeterSizeHeight: 225
            };
        case ProductId.S_SHARE_SAMPLE:
            return {
                // 1.6
                width: 1400, height: 2240,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 771,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 61, canvasMiriMeterSizeHeight: 100
            };
        case ProductId.M_SHARE_SAMPLE:
            return {
                // 1.6
                width: 1400, height: 2240,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 771,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 92, canvasMiriMeterSizeHeight: 150
            };
        case ProductId.L_SHARE_SAMPLE:
            return {
                // 1.605
                width: 2080, height: 3340,
                canvasScreenSizeWidth: 482, canvasScreenSizeHeight: 774,
                canvasScreenPositionX: 0, canvasScreenPositionY: 0,
                canvasMiriMeterSizeWidth: 139, canvasMiriMeterSizeHeight: 225
            };
        default:
            return {};
    }
}

const GetSampleImageURL = function(productId){
    // 1.623
    // 1456*2359
    switch(productId){
        case ProductId.S:
            return "/sample/sample_image_s.png";
        case ProductId.M:
            return "/sample/sample_image_m.png";
        case ProductId.L:
            return "/sample/sample_image_l.png";
        case ProductId.S_SVG:
            return "/sample/sample_image_s.png";
        case ProductId.M_SVG:
            return "/sample/sample_image_m.png";
        case ProductId.L_SVG:
            return "/sample/sample_image_l.png";
        case ProductId.S_SHARE:
            return "/sample/sample_image_s.png";
        case ProductId.M_SHARE:
            return "/sample/sample_image_m.png";
        case ProductId.L_SHARE:
            return "/sample/sample_image_l.png";
        case ProductId.S_SVG_SAMPLE:
            return "/sample/sample_image_s.png";
        case ProductId.M_SVG_SAMPLE:
            return "/sample/sample_image_m.png";
        case ProductId.L_SVG_SAMPLE:
            return "/sample/sample_image_l.png";
        case ProductId.S_SHARE_SAMPLE:
            return "/sample/sample_image_s.png";
        case ProductId.M_SHARE_SAMPLE:
            return "/sample/sample_image_m.png";
        case ProductId.L_SHARE_SAMPLE:
            return "/sample/sample_image_l.png";
        default:
            return "/sample/sample_image_l.png";
    }
}

// classcategory_id2に対応
const PalletData = {
    '4:48': "PC",
    //2XL
    '4:47': "PC",
    //XL
    '4:46': "PC",
    //L
    '4:45': "PC",
    //M
    '4:44': "PC",
    //S
    '4:43': "PB",
    //XS
    '4:42': "PB",
    //WL
    '4:41': "PB",
    //WM
    '4:40': "PB",
    //150
    '4:39': "PB",
    //140
    '4:38': "PB",
    //130
    '4:37': "PB",
    //120
    '4:36': "PA",
    //110
    '4:35': "PA",
    //100
    '4:34': "PA",
    //3XL
    '5:114': "PD",
    //2XL
    '5:113': "PC",
    //XL
    '5:112': "PC",
    //L
    '5:111': "PC",
    //M
    '5:110': "PC",
    //S
    '5:109': "PB",
    //WL
    '5:108': "PB",
    //WM
    '5:107': "PB",
    //160
    '5:106': "PB",
    //150
    '5:105': "PB",
    //140
    '5:104': "PB",
    //130
    '5:103': "PB",
    //120
    '5:102': "PA",
    //110
    '5:101': "PA",
    //100
    '5:100': "PA",
}
// タグ情報の定義
// 場合分けが必要な素材一覧(値はclasscategory_id1)
const MaterialList = {
    "4": {
        "オールカラー": [10, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33],
        "杢グレー専用": [12],
        "オートミール専用": [11],
    },
    "5": {
        "オールカラー": [49, 50, 52, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99],
        "杢グレー専用": [53],
        "オートミール専用": [51],
    }
}
// 白引き回数の0を除外するリスト
const WhiteCountOneOrMoreList = {
    "4": [14, 15, 29, 30],
    "5": [99, 55, 97, 98],
}

const SizeList = [
    {
        sizeId: "34",
        sizeName: "100"
    },
    {
        sizeId: "35",
        sizeName: "110"
    },
    {
        sizeId: "36",
        sizeName: "120"
    },
    {
        sizeId: "37",
        sizeName: "130"
    },
    {
        sizeId: "38",
        sizeName: "140"
    },
    {
        sizeId: "39",
        sizeName: "150"
    },
    {
        sizeId: "40",
        sizeName: "WM"
    },
    {
        sizeId: "41",
        sizeName: "WL"
    },
    {
        sizeId: "42",
        sizeName: "XS"
    },
    {
        sizeId: "43",
        sizeName: "S"
    },
    {
        sizeId: "44",
        sizeName: "M"
    },
    {
        sizeId: "45",
        sizeName: "L"
    },
    {
        sizeId: "46",
        sizeName: "XL"
    },
    {
        sizeId: "47",
        sizeName: "2XL"
    },
    {
        sizeId: "48",
        sizeName: "3XL"
    },
    {
        sizeId: "100",
        sizeName: "100"
    },
    {
        sizeId: "101",
        sizeName: "110"
    },
    {
        sizeId: "102",
        sizeName: "120"
    },
    {
        sizeId: "103",
        sizeName: "130"
    },
    {
        sizeId: "104",
        sizeName: "140"
    },
    {
        sizeId: "105",
        sizeName: "150"
    },
    {
        sizeId: "106",
        sizeName: "160"
    },
    {
        sizeId: "107",
        sizeName: "WM"
    },
    {
        sizeId: "108",
        sizeName: "WL"
    },
    {
        sizeId: "109",
        sizeName: "S"
    },
    {
        sizeId: "109",
        sizeName: "S"
    },
    {
        sizeId: "110",
        sizeName: "M"
    },
    {
        sizeId: "111",
        sizeName: "L"
    },
    {
        sizeId: "112",
        sizeName: "XL"
    },
    {
        sizeId: "113",
        sizeName: "XXL"
    },
    {
        sizeId: "114",
        sizeName: "XXXL"
    },
]
const NewSizeList = {
    "4": [
        {
            sizeId: "34",
            sizeName: "100"
        },
        {
            sizeId: "35",
            sizeName: "110"
        },
        {
            sizeId: "36",
            sizeName: "120"
        },
        {
            sizeId: "37",
            sizeName: "130"
        },
        {
            sizeId: "38",
            sizeName: "140"
        },
        {
            sizeId: "39",
            sizeName: "150"
        },
        {
            sizeId: "40",
            sizeName: "WM"
        },
        {
            sizeId: "41",
            sizeName: "WL"
        },
        {
            sizeId: "42",
            sizeName: "XS"
        },
        {
            sizeId: "43",
            sizeName: "S"
        },
        {
            sizeId: "44",
            sizeName: "M"
        },
        {
            sizeId: "45",
            sizeName: "L"
        },
        {
            sizeId: "46",
            sizeName: "XL"
        },
        {
            sizeId: "47",
            sizeName: "2XL"
        },
        {
            sizeId: "48",
            sizeName: "3XL"
        },
    ],
    "5": [
        {
            sizeId: "100",
            sizeName: "100"
        },
        {
            sizeId: "101",
            sizeName: "110"
        },
        {
            sizeId: "102",
            sizeName: "120"
        },
        {
            sizeId: "103",
            sizeName: "130"
        },
        {
            sizeId: "104",
            sizeName: "140"
        },
        {
            sizeId: "105",
            sizeName: "150"
        },
        {
            sizeId: "106",
            sizeName: "160"
        },
        {
            sizeId: "107",
            sizeName: "WM"
        },
        {
            sizeId: "108",
            sizeName: "WL"
        },
        {
            sizeId: "109",
            sizeName: "S"
        },
        {
            sizeId: "109",
            sizeName: "S"
        },
        {
            sizeId: "110",
            sizeName: "M"
        },
        {
            sizeId: "111",
            sizeName: "L"
        },
        {
            sizeId: "112",
            sizeName: "XL"
        },
        {
            sizeId: "113",
            sizeName: "XXL"
        },
        {
            sizeId: "114",
            sizeName: "XXXL"
        },
    ]
}


// プレビューで使用する背景画像のアルファ値(見え方を変えるため)
const PreviewWhiteInfo = {
    "4": {
        10: [0.87, 0.95, 1],
        11: [0.87, 0.95, 1],
        12: [0.7, 0.95, 1],
        13: [0.2, 0.95, 1],
        14: [0.1, 0.95, 1],
        15: [0, 0.95, 1],
        16: [0, 0.95, 1],
        17: [0, 0.95, 1],
        18: [0, 0.95, 1],
        19: [0, 0.95, 1],
        20: [0, 0.95, 1],
        21: [0, 0.95, 1],
        22: [0.87, 0.95, 1],
        23: [0, 0.95, 1],
        24: [0, 0.95, 1],
        25: [0, 0.95, 1],
        26: [0, 0.95, 1],
        27: [0, 0.95, 1],
        28: [0, 0.95, 1],
        29: [0.1, 0.95, 1],
        30: [0.1, 0.95, 1],
        31: [0, 0.95, 1],
        32: [0, 0.95, 1],
        33: [0, 0.95, 1],
    }
}

// RealtimeDatabaseのテーブル名を定義
const RealtimeDatabaseTableName = {
    HistoryData:"AcryProOrderHistoryData",    // 注文履歴を保存するテーブル
}

// 中央画面の状態の定義
const CenterViewState = {
    Upload:0,
    Preview:1,
    Edit:2,
    OrderHistory:3,
    Shipping:4,
    Option:5,
    Info:6,
    Draft:7,
    SampleUpload:8,
    SamplePreview:9,
    EventManagement:10,
    EventCreate:11,
    EventCreateDesign:12,
    EventEdit:13,
    EventTicketIssue:14,
    TicketOrderConfirm:15,
    TicketIssueHistory:16,
    TicketIssueDetail:17,
    EventDesignUpload:18,
    EventList:19,
    BehalfCreate:20,
    BehalfCreateComplate:21,
    CommonPreview:22,
    FirstTimeFreeTop:23,
    FirstTimeFreeSurvey:24,
    FirstTimeFreeSurveyComplete:25,
}

// 右画面状態の定義
const RightViewState = {
    Cart:0,
    Upload:1,
    Preview:2,
    Edit:3,
    Draft:4,
    SamplePreview:5,
    EventImageUpload:6,
    FirstTimeFreeUpload:7,
}

// プレビューで使用する色の定義
const PreviewColorList = [
    "#FFFFFF",
    "#595959",
    "#FF0000",
];

const EditConfig = {
    MinScale:0.3,
    MaxScale:10.0,
}

const PrefName = [
    "未設定",
    "北海道",
    "青森県",
    "岩手県",
    "宮城県",
    "秋田県",
    "山形県",
    "福島県",
    "茨城県",
    "栃木県",
    "群馬県",
    "埼玉県",
    "千葉県",
    "東京都",
    "神奈川県",
    "新潟県",
    "富山県",
    "石川県",
    "福井県",
    "山梨県",
    "長野県",
    "岐阜県",
    "静岡県",
    "愛知県",
    "三重県",
    "滋賀県",
    "京都府",
    "大阪府",
    "兵庫県",
    "奈良県",
    "和歌山県",
    "鳥取県",
    "島根県",
    "岡山県",
    "広島県",
    "山口県",
    "徳島県",
    "香川県",
    "愛媛県",
    "高知県",
    "福岡県",
    "佐賀県",
    "長崎県",
    "熊本県",
    "大分県",
    "宮崎県",
    "鹿児島県",
    "沖縄県",
]

const PaymentType = {
    CREDIT:10,
    BANK_TRANSFER:12,
    ACRY_PRO_FREE:13,
}

const AcryShippingFeeBase = 319;
const AcryShippingFee = 350;

const AcryTicketData = {
    PRImage1X:1080,
    PRImage1Y:1080,
    PRImage2X:1080,
    PRImage2Y:2000,
    PRImageMaxSize: 10, // MB
}

const PegeViewData = [
    { viewId: CenterViewState.Info, path: '/info', title: 'お知らせ | ACRY PRO' },

    { viewId: CenterViewState.Upload, path: '/order', title: '注文TOP | ACRY PRO' },
    { viewId: CenterViewState.Preview, path: '/order/designupload', title: 'デザイン入稿 | ACRY PRO' },
    { viewId: CenterViewState.Edit, path: '/order/designedit', title: 'デザイン編集 | ACRY PRO' },

    { viewId: CenterViewState.FirstTimeFreeTop, path: '/order/freeorder', title: '初回無料お試しサービス | ACRY PRO' },
    { viewId: CenterViewState.FirstTimeFreeSurvey, path: '/order/freeordersurvey', title: '初回無料お試しサービスアンケート | ACRY PRO' },
    { viewId: CenterViewState.FirstTimeFreeSurveyComplete, path: '/order/freeordercomplete', title: '初回無料お試しサービス登録完了 | ACRY PRO' },
    { viewId: CenterViewState.BehalfCreate, path: '/order/behalfcreate', title: 'カットライン作成代行 | ACRY PRO' },
    { viewId: CenterViewState.BehalfCreateComplate, path: '/order/behalfcreatecomplete', title: 'カットライン作成代行登録完了 | ACRY PRO' },

    { viewId: CenterViewState.SampleUpload, path: '/sampleorder', title: 'サンプル注文TOP | ACRY PRO' },
    { viewId: CenterViewState.SamplePreview, path: '/sampleorder/designupload', title: 'デザイン入稿 | ACRY PRO' },

    { viewId: CenterViewState.Draft, path: '/designlist', title: '下書き・デザイン履歴 | ACRY PRO' },

    { viewId: CenterViewState.OrderHistory, path: '/orderhistory', title: '注文履歴 | ACRY PRO' },

    { viewId: CenterViewState.Shipping, path: '/usersetting', title: 'お客様情報・配送先 | ACRY PRO' },

    { viewId: CenterViewState.Option, path: '/optionitem', title: 'オプションアイテム | ACRY PRO' },

    { viewId: CenterViewState.EventManagement, path: '/acryticket', title: 'ACRY TICKET TOP | ACRY PRO' },
    { viewId: CenterViewState.EventCreate, path: '/acryticket/createstep1', title: 'ACRY TICKET Step1 | ACRY PRO' },
    { viewId: CenterViewState.EventCreateDesign, path: '/acryticket/createstep2', title: 'ACRY TICKET Step2 | ACRY PRO' },
    { viewId: CenterViewState.EventDesignUpload, path: '/acryticket/designupload', title: 'ACRY TICKET デザイン入稿 | ACRY PRO' },
    { viewId: CenterViewState.EventTicketIssue, path: '/acryticket/createstep3', title: 'ACRY TICKET Step3 | ACRY PRO' },
    { viewId: CenterViewState.TicketOrderConfirm, path: '/acryticket/createstep4', title: 'ACRY TICKET Step4 | ACRY PRO' },
    { viewId: CenterViewState.EventList, path: '/acryticket/ticketlist', title: 'ACRY TICKET チケット一覧 | ACRY PRO' },
    { viewId: CenterViewState.EventEdit, path: '/acryticket/ticketdetail', title: 'ACRY TICKET チケット詳細 | ACRY PRO' },
    { viewId: CenterViewState.TicketIssueHistory, path: '/acryticket/issuehistory', title: 'ACRY TICKET 発行コード履歴 | ACRY PRO' },
    { viewId: CenterViewState.TicketIssueDetail, path: '/acryticket/issuedetail', title: 'ACRY TICKET 発行コード詳細 | ACRY PRO' },

    { viewId: CenterViewState.CommonPreview, path: '/designupload', title: 'デザイン入稿 | ACRY PRO' },
]

export {ProductId, AcrylProductIds, AcrylTicketIds, AcrylSampleProductIds, AcrylShareProductIds, AcrylSvgProductIds, PreviewWhiteInfo, CanvasSizeData, GetCanvasSize, GetSampleImageURL, PalletData, MaterialList, SizeList,NewSizeList, WhiteCountOneOrMoreList, RealtimeDatabaseTableName, CenterViewState, RightViewState, PreviewColorList, GetAcryProductPrice, GetAcryProductSizeText, EditConfig, PrefName, PaymentType, AcryShippingFeeBase, AcryShippingFee, AcryTicketData, PegeViewData }
